export const environment = {
   production: true,
   timeStamp: 'Mon Sep 20 2021 15:26:05 GMT+0200 (Midden-Europese zomertijd)'
};
